module.exports = __webpack_public_path__ + "img/abandon-launch.c72d229f.jpg";